import React from 'react';
function Users({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M16.09 19.364v-1.637a3.273 3.273 0 00-3.272-3.272H6.273A3.273 3.273 0 003 17.727v1.637M9.545 11.182a3.273 3.273 0 100-6.546 3.273 3.273 0 000 6.546zM21 19.364v-1.637a3.273 3.273 0 00-2.455-3.166M15.273 4.743a3.273 3.273 0 010 6.34"
      />
    </svg>
  );
}

export default Users;
